module.exports = __webpack_public_path__ + "static/media/05660035-XDU0wSgs.23055716.JPG";